import articleWispehone from "./work-articles/articleWisephone";
import articleTechAddictionQuiz from "./work-articles/articleTechAddictionQuiz";
import articleKirkElliott from "./work-articles/articleKirkElliott";

const work_ux = [
  articleKirkElliott,
  articleWispehone,
  articleTechAddictionQuiz
]
export default work_ux;